import React, { useState, useEffect } from "react";
import EditJump from "./Edit";
import InfoIcon from "@material-ui/icons/Info";
import IconButton from "@material-ui/core/IconButton";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Link } from "react-router-dom";
import { Row, Col, Label } from "reactstrap";
import {
  Avatar,
  Box,
  Card,
  CardHeader,
  CardContent,
  Checkbox,
  Grid,
  Paper,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  FormLabel,
  FormGroup,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Slide,
  FormControlLabel,
  Button,
  Chip,
  // RadioGroup,
  // Radio,
} from "@mui/material";
import Radio from "@material-ui/core/Radio";
import DeleteIcon from "@mui/icons-material/Delete";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Jumphosts = () => {
  const [selectedCustomerIds, setSelectedCustomerIds] = useState([]);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const [searchitems, setSearchItems] = React.useState(0);

  window.sessionStorage.removeItem("userdata");
  const [selectedValue, setSelectedValue] = React.useState({
    ipaddress: true,
    domainname: true,
  });

  const handleChange1 = (event) => {
    setSelectedValue(event.target.value);
  };

  const [state, setState] = React.useState({
    name: "",
    description: "",
    jumphost_ip: "",
    port: "",
    credential_id: "",
    os_type: "",
    domain: "",
    delete_id: "",
    errorMessage: "",
  });
  console.log(state);

  const [jumphostlist, setjumphost] = useState([]);

  const [visible, setVisible] = useState(true);

  const onDismiss = () => setVisible(false);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };
  const handleSubmitClick = (e) => {
    e.preventDefault();
    if (state.domain === "") {
      var pattern =
        /\b(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\b/;
      if (pattern.test(state.jumphost_ip)) {
        if (state.port === "") {
          if (state.os_type === "windows") {
            setState({ port: "5896" });
            const register = {
              name: state.name,
              description: state.description,
              jumphost_ip: state.jumphost_ip,
              port: "5896",
              credential_id: state.credential_id,
              os_type: state.os_type,
            };
            fetch(`${process.env.REACT_APP_API_URL}/api/jumphost/`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + window.localStorage.getItem("token"),
              },
              body: JSON.stringify(register),
            })
              .then((response) => response.json())
              .then((data) => {
                if (data.name) {
                  window.location.reload();
                } else {
                  if (data.username) {
                    setState({ errorMessage: data.name[0] });
                  }
                }
              })
              .catch((error) => {
                console.error(error);
              });
          } else {
            setState({ port: "22" });
            const register = {
              name: state.name,
              description: state.description,
              jumphost_ip: state.jumphost_ip,
              port: "22",
              credential_id: state.credential_id,
              os_type: state.os_type,
            };
            fetch(`${process.env.REACT_APP_API_URL}/api/jumphost/`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + window.localStorage.getItem("token"),
              },
              body: JSON.stringify(register),
            })
              .then((response) => response.json())
              .then((data) => {
                if (data.name) {
                  window.location.reload();
                  window.location.href = "/admin/jumphostmanagement";
                } else {
                  if (data.username) {
                    setState({ errorMessage: data.name[0] });
                  }
                }
              })
              .catch((error) => {
                console.error(error);
              });
          }
        } else {
          const register = {
            name: state.name,
            description: state.description,
            jumphost_ip: state.jumphost_ip,
            port: state.port,
            credential_id: state.credential_id,
            os_type: state.os_type,
          };
          fetch(`${process.env.REACT_APP_API_URL}/api/jumphost/`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + window.localStorage.getItem("token"),
            },
            body: JSON.stringify(register),
          })
            .then((response) => response.json())
            .then((data) => {
              if (data.name) {
                window.location.reload();
                window.location.href = "/admin/jumphostmanagement";
              } else {
                if (data.username) {
                  setState({ errorMessage: data.name[0] });
                }
              }
            })
            .catch((error) => {
              console.error(error);
            });
        }
      } else {
        setState({ errorMessage: "The IP Address entered is invalid!" });
      }
    }
    if (state.jumphost_ip === "") {
      const isValidDomain = require("is-valid-domain");
      if (isValidDomain(state.domain)) {
        if (state.port === "") {
          if (state.os_type === "windows") {
            setState({ port: "5896" });
            const register = {
              name: state.name,
              description: state.description,
              jumphost_ip: state.domain,
              port: "5896",
              credential_id: state.credential_id,
              os_type: state.os_type,
            };
            fetch(`${process.env.REACT_APP_API_URL}/api/jumphost/`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + window.localStorage.getItem("token"),
              },
              body: JSON.stringify(register),
            })
              .then((response) => response.json())
              .then((data) => {
                if (data.name) {
                  window.location.reload();
                  window.location.href = "/admin/jumphostmanagement";
                } else {
                  if (data.username) {
                    setState({ errorMessage: data.name[0] });
                  }
                }
              })
              .catch((error) => {
                console.error(error);
              });
          } else {
            setState({ port: "22" });
            const register = {
              name: state.name,
              description: state.description,
              jumphost_ip: state.domain,
              port: "22",
              credential_id: state.credential_id,
              os_type: state.os_type,
            };
            fetch(`${process.env.REACT_APP_API_URL}/api/jumphost/`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + window.localStorage.getItem("token"),
              },
              body: JSON.stringify(register),
            })
              .then((response) => response.json())
              .then((data) => {
                if (data.name) {
                  window.location.reload();
                  window.location.href = "/admin/jumphostmanagement";
                } else {
                  if (data.username) {
                    setState({ errorMessage: data.name[0] });
                  }
                }
              })
              .catch((error) => {
                console.error(error);
              });
          }
        } else {
          const register = {
            name: state.name,
            description: state.description,
            jumphost_ip: state.domain,
            port: state.port,
            credential_id: state.credential_id,
            os_type: state.os_type,
          };
          fetch(`${process.env.REACT_APP_API_URL}/api/jumphost/`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + window.localStorage.getItem("token"),
            },
            body: JSON.stringify(register),
          })
            .then((response) => response.json())
            .then((data) => {
              if (data.name) {
                window.location.reload();
                window.location.href = "/admin/jumphostmanagement";
              } else {
                if (data.username) {
                  setState({ errorMessage: data.name[0] });
                }
              }
            })
            .catch((error) => {
              console.error(error);
            });
        }
      } else {
        setState({
          errorMessage: "The Domain Name entered is invalid!",
        });
      }
    }
  };

  const [credlist, setcredlist] = useState([]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/credentiallist/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => setcredlist(resp))
      .catch((error) => {
        console.error(error);
        window.location.href = "/something_went_wrong";
      });
  }, []);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/organizationjumphostlist/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
          window.localStorage.setItem("user_access", data.detail);
        } else {
          setjumphost(data);
        }
      })
      .catch((error) => {
        console.error(error);
        window.location.href = "/something_went_wrong";
      });
  }, []);

  const Delete = (jumphostId) => {
    return function () {
      fetch(`${process.env.REACT_APP_API_URL}/api/jumphost/${jumphostId}/`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + window.localStorage.getItem("token"),
        },
      })
        .then((response) => response.json())
        .then((data) => {
          window.location.reload();
        })
        .catch((error) => {
          window.location.reload();
        });
    };
  };

  const handleSelectAll = (event) => {
    let newSelectedCustomerIds;

    if (event.target.checked) {
      newSelectedCustomerIds = jumphostlist.map((jump) => jump.id);
    } else {
      newSelectedCustomerIds = [];
    }

    setSelectedCustomerIds(newSelectedCustomerIds);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedCustomerIds.indexOf(id);
    let newSelectedCustomerIds = [];

    if (selectedIndex === -1) {
      newSelectedCustomerIds = newSelectedCustomerIds.concat(
        selectedCustomerIds,
        id
      );
    } else if (selectedIndex === 0) {
      newSelectedCustomerIds = newSelectedCustomerIds.concat(
        selectedCustomerIds.slice(1)
      );
    } else if (selectedIndex === selectedCustomerIds.length - 1) {
      newSelectedCustomerIds = newSelectedCustomerIds.concat(
        selectedCustomerIds.slice(0, -1)
      );
    } else if (selectedIndex > 0) {
      newSelectedCustomerIds = newSelectedCustomerIds.concat(
        selectedCustomerIds.slice(0, selectedIndex),
        selectedCustomerIds.slice(selectedIndex + 1)
      );
    }

    setSelectedCustomerIds(newSelectedCustomerIds);
  };

  const handleLimitChange = (event) => {
    // setLimit(event.target.value);
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };
  const [open, setOpen] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };

  function popup(userId) {
    window.sessionStorage.setItem("userId", userId);
    if (userId !== "") {
      toggle();
    }
  }
  const [open2, setOpen2] = useState(false);
  const [focusAfterClose2] = useState(true);
  const toggle2 = () => setOpen2(!open2);

  function del(deleteid) {
    setState({ delete_id: deleteid });
  }

  const handleClose = () => {
    setOpen(false);
  };
  const toggle = () => setOpen(!open);

  function refreshPage() {
    window.location.reload();
  }
  const isValidDomain = require("is-valid-domain");

  const unique = [
    ...new Set(
      jumphostlist.sort((a, b) => (a.serial_number > b.serial_number ? -1 : 1))
    ),
  ];

  const [one, setone] = React.useState(false);

  const oneopen = () => {
    setone(true);
  };

  const oneClose = () => {
    setone(false);
  };
  const cloumnName = "name";

  return (
    <>
      <form className="md:flex hidden flex-row flex-wrap items-center lg:ml-auto mr-3">
        <div className="relative flex flex-wrap items-stretch">
          <span className="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 absolute bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3">
            <i className="fas fa-search"></i>
          </span>
          <input
            type="text"
            placeholder="Search Jump Host Name here..."
            onChange={(event) => {
              console.log(event.target.value);
              setSearchItems(event.target.value);
            }}
            className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white bg-white rounded text-sm shadow outline-none focus:outline-none focus:ring w-full pl-10"
          />
        </div>
      </form>
      <br />
      <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white border-0">
        <Dialog
          PaperProps={{
            sx: {
              width: "80%",
            },
          }}
          open={open}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleClose}
          aria-describedby="alert-dialog-slide-description"
        >
          <h2
            style={{
              textAlign: "center",
              fontSize: "18px",
              fontWeight: "810",
              color: "rgb(48, 68, 115)",
              fontFamily: "sans-serif",
              lineHeight: "4.5rem",
            }}
          >
            ADD JUMP HOSTS
          </h2>
          <DialogContent>
            <FormLabel htmlFor="name">
              <strong>Name</strong>
            </FormLabel>

            <TextField
              fullWidth
              type="text"
              id="name"
              className="form-control"
              value={state.name}
              onChange={handleChange}
              variant="outlined"
              size="small"
              placeholder="Enter Your Jump Host Name here"
            />
            <br />
            <br />
            <FormLabel htmlFor="description">
              <strong>Description</strong>
            </FormLabel>
            <TextField
              type="text"
              id="description"
              className="form-control"
              value={state.description}
              onChange={handleChange}
              placeholder="Short detail about the Jump Host"
              variant="outlined"
              size="small"
              fullWidth
            />

            <br />
            <br />
            <Row>
              <Col>
                <strong>
                  <Label>IP Address</Label>
                </strong>
                <Radio
                  checked={selectedValue === "ipaddress"}
                  onChange={handleChange1}
                  value="ipaddress"
                  name="radio-button-demo"
                  inputProps={{ "aria-label": "C" }}
                />
                {selectedValue == "ipaddress" ? (
                  <IconButton
                    color="white"
                    size="sm"
                    title="For non Jump-Host connection IP Address should be accessible over the internet"
                    data-toggle="collapse"
                  >
                    <InfoIcon fontSize="small" />
                  </IconButton>
                ) : (
                  ""
                )}
                <strong>
                  <Label>Domain Name</Label>
                </strong>
                <Radio
                  checked={selectedValue === "domainname"}
                  onChange={handleChange1}
                  value="domainname"
                  name="radio-button-demo"
                  inputProps={{ "aria-label": "C" }}
                />

                {selectedValue == "domainname" ? (
                  <IconButton
                    color="white"
                    size="sm"
                    title="DNS should be publicly available and accessible over internet"
                    data-toggle="collapse"
                  >
                    <InfoIcon fontSize="small" />
                  </IconButton>
                ) : (
                  ""
                )}
              </Col>
            </Row>
            {selectedValue == "domainname" ? (
              <FormGroup style={{ marginBottom: "2.5rem" }}>
                <FormLabel htmlFor="domain">
                  <strong>Jump Host Domain Name</strong>
                </FormLabel>

                <TextField
                  fullWidth
                  type="text"
                  id="domain"
                  className="form-control"
                  value={state.domain}
                  onChange={handleChange}
                  variant="outlined"
                  size="small"
                  placeholder="Jumphost DNS"
                />

                {state.domain ? (
                  <p
                    style={{
                      marginLeft: "24px",
                      width: "90%",
                    }}
                  >
                    {" "}
                    {isValidDomain(state.domain) ? null : (
                      <span style={{ color: "red" }}>*Invalid Domain Name</span>
                    )}
                  </p>
                ) : (
                  ""
                )}
              </FormGroup>
            ) : selectedValue == "ipaddress" ? (
              <FormGroup style={{ marginBottom: "2.5rem" }}>
                <FormLabel htmlFor="jumphost_ip" className="ml-4">
                  <strong>Jumphost IP Address</strong>
                </FormLabel>

                <TextField
                  fullWidth
                  type="text"
                  id="jumphost_ip"
                  className="form-control"
                  value={state.jumphost_ip}
                  onChange={handleChange}
                  variant="outlined"
                  size="small"
                  placeholder="Jumphost IP"
                  variant="outlined"
                />

                {(() => {
                  if (state.jumphost_ip) {
                    return (
                      <p
                        style={{
                          marginLeft: "24px",
                          width: "90%",
                        }}
                      >
                        {" "}
                        {/\b(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\b/.test(
                          state.jumphost_ip
                        ) ? null : (
                          <span style={{ color: "red" }}>
                            *Invalid IP Address
                          </span>
                        )}
                      </p>
                    );
                  }
                })()}
              </FormGroup>
            ) : (
              ""
            )}
            <FormGroup style={{ marginBottom: "2.5rem" }}>
              <FormLabel htmlFor="os_type">
                <strong> OS type</strong>
              </FormLabel>
              <TextField
                className="form-control"
                type="select"
                id="os_type"
                placeholder="-- Select the OS type --"
                name="os_type"
                value={state.os_type}
                onChange={handleChange}
                variant="outlined"
                size="small"
                fullWidth
                required
                select
                SelectProps={{ native: true }}
              >
                {" "}
                <option>-- Select the OS type --</option>
                <option value="windows">Windows</option>
                <option value="linux">Linux</option>
              </TextField>
            </FormGroup>
            <FormGroup style={{ marginBottom: "2.5rem" }}>
              <FormLabel htmlFor="port">
                <strong>Port</strong>
              </FormLabel>
              <TextField
                fullWidth
                placeholder="Enter the SSH(22) or WinRM(5986) port number"
                type="number"
                autoComplete="new-port"
                name="port"
                id="port"
                className="form-control"
                variant="outlined"
                size="small"
                value={state.port}
                onChange={handleChange}
              />
            </FormGroup>

            <FormLabel htmlFor="credential_id">
              <strong>Credentials</strong>
            </FormLabel>
            <FormGroup style={{ marginBottom: "2.5rem" }}>
              <TextField
                className="form-control"
                type="select"
                id="credential_id"
                placeholder="-- Select the credential --"
                name="credential_id"
                value={state.credential_id}
                onChange={handleChange}
                variant="outlined"
                size="small"
                fullWidth
                required
                select
                SelectProps={{ native: true }}
              >
                {" "}
                <option>-- Select the Credentials--</option>
                {credlist.map((credlist) => {
                  return (
                    <React.Fragment>
                      <option value={credlist.id}>{credlist.name}</option>
                    </React.Fragment>
                  );
                })}
              </TextField>
            </FormGroup>
          </DialogContent>
          <DialogActions>
            <button
              className="bg-blueGray-100 text-black font-bold active:bg-blueGray-600 uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
              onClick={toggle}
            >
              Cancel
            </button>
            <button
              className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
              onClick={handleSubmitClick}
            >
              Create
            </button>
          </DialogActions>
        </Dialog>
        <Card>
          <CardHeader
            action={
              <React.Fragment>
                <button
                  className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                  type="button"
                  onClick={handleClickOpen}
                >
                  Add Jumphosts
                </button>
              </React.Fragment>
            }
            title="JUMP-HOST LIST"
          />
          <Paper sx={{ width: "100%" }}>
            <TableContainer sx={{ maxHeight: 1050 }}>
              <Table>
                <TableHead className="bg-lightBlue-200">
                  <TableRow>
                    <TableCell align="center">S.No</TableCell>
                    <TableCell align="center">Name</TableCell>
                    <TableCell align="center">Port</TableCell>
                    {window.localStorage.getItem("audit_run_access") ===
                    "You do not have permission to perform this action." ? (
                      ""
                    ) : (
                      <React.Fragment>
                        <TableCell align="center">Edit</TableCell>
                        <TableCell align="center">Delete</TableCell>
                      </React.Fragment>
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {unique
                    // .slice(0, limit)
                    .slice(page * limit, page * limit + limit)
                    .filter((val) => {
                      if (searchitems == "") {
                        return val;
                      } else if (
                        val[cloumnName]
                          .toLowerCase()
                          .includes(searchitems.toLowerCase())
                      ) {
                        return val;
                      }
                    })
                    .map((jump) => (
                      <TableRow
                        hover
                        key={jump.id}
                        selected={selectedCustomerIds.indexOf(jump.id) !== -1}
                      >
                        <TableCell align="center">
                          {jump.serial_number}
                        </TableCell>
                        <TableCell align="center">{jump.name}</TableCell>
                        <TableCell align="center">
                          {jump.port ? jump.port : "-"}
                        </TableCell>
                        {window.localStorage.getItem("audit_run_access") ===
                        "You do not have permission to perform this action." ? (
                          ""
                        ) : (
                          <React.Fragment>
                            <TableCell align="center">
                              {/\b(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\b/.test(
                                jump.jumphost_ip
                              ) ? (
                                <EditJump JumpID={jump.id} IPDNS="ipaddress" />
                              ) : (
                                <EditJump JumpID={jump.id} IPDNS="domainname" />
                              )}
                            </TableCell>
                            <TableCell align="center">
                              <IconButton
                                title="Delete"
                                aria-label="delete"
                                id="delete"
                                style={{
                                  padding: "0px",
                                  color: "#e68383",
                                }}
                              >
                                <DeleteIcon
                                  fontSize="small"
                                  onClick={() => {
                                    oneopen();
                                    window.sessionStorage.setItem(
                                      "jumphostname",
                                      jump.name
                                    );
                                    del(jump.id);
                                  }}
                                />
                              </IconButton>
                            </TableCell>
                          </React.Fragment>
                        )}
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
          <TablePagination
            component="div"
            count={jumphostlist.length}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleLimitChange}
            page={page}
            rowsPerPage={limit}
            rowsPerPageOptions={[5, 10, 25]}
          />
        </Card>
        <Dialog
          open={one}
          fullWidth
          TransitionComponent={Transition}
          keepMounted
          onClose={oneClose}
          aria-describedby="alert-dialog-slide-description"
        >
          <h2
            style={{
              textAlign: "center",
              fontSize: "18px",
              fontWeight: "810",
              color: "rgb(48, 68, 115)",
              fontFamily: "sans-serif",
              lineHeight: "4.5rem",
            }}
          >
            Delete Jumphost
          </h2>

          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              Are you sure you want to delete{" "}
              <strong>{window.sessionStorage.getItem("credentialname")}</strong>{" "}
              ?{" "}
            </DialogContentText>
          </DialogContent>

          <DialogActions>
            <button
              className="bg-blueGray-100 text-black font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
              onClick={() => refreshPage()}
              size="sm"
            >
              Cancel
            </button>
            <button
              className="bg-red-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
              onClick={Delete(state.delete_id)}
            >
              Delete
            </button>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
};

export default Jumphosts;